import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"

export default function Topsellernew() {

  // 配置默认排序
  const defaultSort = {
    sortDirection: "DESC",
    sortBy: "addTime"
  }

  return (
    <>
      <Head>
        <title>{`New Arrivals | Shop Online Home Garden Furniture Bed Frames Makeup Mirrors Cameras Sports Equipment`}</title>
        <meta name="keywords" content={`New arrivals, new arrival furniture, bed frames, office chairs, queen bed frame, vanity mirror, makeup mirrors, kids cameras, children cameras, garden supplies, sport equipment, pet supplies, dog crate, cat scratching post, new arrivals online, beauty mirror, landscape supplies, garden supplies, kitchen supplies, cabinets`}></meta>
        <meta name="description" content={`Transform your home, garden and lifestyle with the CrazySales New Arrivals collection. This category has a wide range of the latest arrivals like bed frames, kitchen cabinets, makeup mirrors, kids cameras, sports equipment, and pet accessories.`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout notStickyNavbar={true}>
        <FeaturedSection type="new-arrival" defaultSort={defaultSort} />
      </DefaultLayout>
    </>
  )
}